// src/com/bbs_pkg/announce_bbs/AnnounceBbs.js
import React, {useEffect, useState, useRef} from 'react';
// import { styled  } from '@mui/material/styles';
import CachedIcon from '@mui/icons-material/Cached'; // refresh
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PageviewIcon from '@mui/icons-material/Pageview';
import EngineeringIcon from '@mui/icons-material/Engineering';
import {
    ContentConainer, ContentHeader, ControlBox, ToolBox
} from '../../../common/TopViewControl';
import { useConfirmDialog } from '../../../common/AppConfirmDialog';
import FlexyTable from '../../../common/flexytable/FlexyTable';
import DateRangePicker from '../../../common/DateRangePicker';
import { BbsInfoDict } from '../BbsInfoDict';
import ValueMisc from '../../../value/ValueMisc';
// import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import { AppObject, AppStyle, AppWord } from '../../../value/AppConst';
import {
    authTableTreeRepo, bbsAnnounceListRepo, ShowDebugRepo, userInfoRepo
} from '../../../value/AppModel';
import {
    LIST_BBS_INFO, GET_BBS_INFO, ADD_BBS_INFO, EDIT_BBS_INFO, REMOVE_BBS_INFO
} from '../BbsInfoGql';
import { useLazyQuery, useMutation, useReactiveVar } from '@apollo/client';
import { useAlertSetter, useAuthorizationCheck } from '../../../api/app-hook';
import AnnounceBbsView from './AnnounceBbsView';
import AnnounceBbsInput from './AnnounceBbsInput';
import { Button, IconButton } from '@mui/material';
import { useSnackbar } from 'notistack';

const TheBbsTypeCode = BbsInfoDict.bbcType.Announce.code;

/**
 * 공지사항 게시판 View-Controller
 * @param {*} param0 
 * @returns 
 */
export default function AnnounceBbs({
    viewServiceTags,
    show = true,
}) {
    const sessionInfo = useReactiveVar(userInfoRepo);
    const showDebug = useReactiveVar(ShowDebugRepo);
    // const [dateFrom, setDateFrom] = useState(dayjs(ValueMisc.getDateAgo(5)));
    const [dateFrom, setDateFrom] = useState(ValueMisc.getYMD(ValueMisc.getDateAgo(5)));
    // const [dateTo, setDateTo] = useState(dayjs(new Date()));
    const [dateTo, setDateTo] = useState(ValueMisc.getYMD());
    const [viewerState, setViewerState] = useState(AppObject.EmptyViewerState);
    const [editorState, setEditorState] = useState(AppObject.EmptyViewerState);
    const bbsAnnounceListData = useReactiveVar(bbsAnnounceListRepo); // {when, records}
    const authTableTree = useReactiveVar(authTableTreeRepo);
    const checkAuth = useAuthorizationCheck();
    const openConfirmDialog = useConfirmDialog();
    const addAlert = useAlertSetter();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const lastReloadRef = useRef(0);
    const isEditingRef = useRef(false); // 플래그 생성

    const [getBbsInfoList, responseList] = useLazyQuery(LIST_BBS_INFO, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data) => {onCompleteGetList(data)},
		onError: (error) => {addAlert({title: BbsInfoDict.errorTitle.Get, message: [error.message]})},
    });

    const [getBbsInfoItem, responseItem] = useLazyQuery(GET_BBS_INFO, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data) => {onCompleteGetItem(data)},
        onError: (error) => {addAlert({title: BbsInfoDict.errorTitle.Get, message: [error.message]})},
    });
    
    // ##### GraphQL Mutation. 'onError' for prevent from printing error at console (Uncaught exception) ###
    const [addBbsInfo, responseAdd] = useMutation( ADD_BBS_INFO, {
		onCompleted: (data, option) => onCompleteAdd(data, option), 
		onError: (error) => {addAlert({title: BbsInfoDict.errorTitle.Add, message: error.message.split('\n')})}
	} );
    const [editBbsInfo, responseEdit] = useMutation( EDIT_BBS_INFO, {
		onCompleted: (data, option) => onCompleteEdit(data, option),
		onError: (error) => {addAlert({title: BbsInfoDict.errorTitle.Edit, message: [error.message]})}
	} );
    const [removeBbsInfo, responseRemove] = useMutation( REMOVE_BBS_INFO, {
		onCompleted: (data, option) => onCompleteRemove(data, option),
		onError: (error) => {addAlert({title: BbsInfoDict.errorTitle.Remove, message: [error.message]})}
	});

    const getWholeBbsInfoList = () => {
        const from = dateFrom || ValueMisc.getYMD(ValueMisc.getDateAgo(5));
        const till = dateTo || ValueMisc.getYMD();
        getBbsInfoList({variables:{bbsTypeCd:TheBbsTypeCode, dateFrom: from, dateTill: till }});
        lastReloadRef.current = new Date().getTime()/1000;
    };

    useEffect(() => {
        // check when < too-long-ago or records is empty of bbsAnnounceListData
        const diff = new Date().getTime()/1000 - bbsAnnounceListData.when; // seconds < 5 minutes
        if(diff > 300) {
            getWholeBbsInfoList();
        }
    }, []);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data) => {
        if(data.bbsInfoList) {
            bbsAnnounceListRepo({when:new Date().getTime()/1000, records:data.bbsInfoList});
        }
    };

    const onCompleteGetItem = (data) => {
        if(data.bbsInfoItem) {
            if(isEditingRef.current) setEditorState({open: true, item: data.bbsInfoItem});
            else setViewerState({open: true, item: data.bbsInfoItem});
        }
        else {
            addAlert({title: BbsInfoDict.errorTitle.Get, message: ['해당 게시물을 찾을 수 없습니다.']});
        }
    };

    const onCompleteAdd = (data) => {
        if(data.bbsInfoAdd.ok) {
            setEditorState(AppObject.EmptyViewerState);
            getWholeBbsInfoList();
            // 파일 업로드를 할 수 있도록 viewer 열기
            isEditingRef.current = false; // viewer 모드로 열기
            getBbsInfoItem({variables:{
                bbsTypeCd:TheBbsTypeCode, 
                bbsInfoSeq: data.bbsInfoAdd.item.bbsInfoSeq
            }});
        }
        else addAlert({title: BbsInfoDict.errorTitle.Add, message: [data.bbsInfoAdd.message]});
    };

    const onCompleteEdit = (data) => {
        if(data.bbsInfoEdit.ok) {
            setEditorState(AppObject.EmptyViewerState);
            getWholeBbsInfoList();
        }
        else addAlert({title: BbsInfoDict.errorTitle.Edit, message: [data.bbsInfoEdit.message]});
    };

    const onCompleteRemove = (data) => {
        if(data.bbsInfoRemove.ok) getWholeBbsInfoList();
        else addAlert({title: BbsInfoDict.errorTitle.Remove, message: [data.bbsInfoRemove.message]});
    };

    // ************** Event Handlers **************

    const onClickReload = () => {
        const diff = new Date().getTime()/1000 - lastReloadRef.current;
        if(diff < 3) {
            enqueueSnackbar(AppWord.ReloadNotIn3Sec, {variant:'info', autoHideDuration:2000});
        }
        else getWholeBbsInfoList();
    };

    const onClickAdd = () => {
        setEditorState({open: true, item: null});
    };

    const onDoubleClickRow = (record) => {
        isEditingRef.current = false;
        getBbsInfoItem({variables:{bbsTypeCd:TheBbsTypeCode, bbsInfoSeq:record.bbsInfoSeq}});
    };

    const onRequestReloadItem = (bbsInfoSeq) => {
        // viewer 또는 editor에서 요청. 따라서 isEditingRef 설정 하면 안됨.
        getBbsInfoItem({variables:{bbsTypeCd:TheBbsTypeCode, bbsInfoSeq: bbsInfoSeq}});
        // List too
        getWholeBbsInfoList();
    };

    const onCloseView = () => {
        setViewerState(AppObject.EmptyViewerState);
    };

    const onRequestEditFromViewer = (item) => {
        setViewerState(AppObject.EmptyViewerState);
        isEditingRef.current = true;
        setEditorState({open: true, item: item});
    };

    const onRequestEdit = (item) => {
        isEditingRef.current = true;
        getBbsInfoItem({variables:{bbsTypeCd:TheBbsTypeCode, bbsInfoSeq:item.bbsInfoSeq}});
    };

    const onClickGetList = () => {
        const from = dateFrom; //.format(AppWord.YMD_FOR_INPUT);
        const to = dateTo; //.format(AppWord.YMD_FOR_INPUT);
        const param = {variables:{bbsTypeCd:TheBbsTypeCode, dateFrom:from, dateTill:to}};
        getBbsInfoList(param);
    };

    const onRequestSave = (param, isEdit) => {
        const mutParam = {variables:{bbsInfo:param}};
        if(isEdit) editBbsInfo(mutParam);
        else addBbsInfo(mutParam);
    };

    const confirmRemoveBbsInfo = async (item) => {
        const confirm = await openConfirmDialog({
                title:'공지사항 삭제',
                content:[`'${item.title}'을 삭제합니다.`, '삭제후에는 복구할 수 없습니다. 계속하시겠습니까?']
            }
        );
        
        if(confirm) {
            removeBbsInfo({variables:{bbsInfo:{bbsTypeCd:item.bbsTypeCd, bbsInfoSeq:item.bbsInfoSeq}}});
        }
    };

    const onRequestRemove = (item) => {
        if(item.regUser === sessionInfo.user.userId) {
            confirmRemoveBbsInfo(item);
        }
        else addAlert(AppObject.alertNotWriter);
    };

    const onClickToolOnRow = (toolId, row) => {
        switch(toolId) {
            case AppObject.command.DELETE: onRequestRemove(row); break;
            case AppObject.command.EDIT: onRequestEdit(row); break;
            case AppObject.command.VIEW: onDoubleClickRow(row); break;
            default: return;
        }
    };

    const canAdd = checkAuth(authTableTree.tree.pr_bbs_info_add_announce); // pseudo procedure from pr_bbs_info_add
    const tools = [
                {id:AppObject.command.VIEW, icon:<PageviewIcon/>, },
    ];

    if(canAdd) {
        tools.push(
            {id:AppObject.command.EDIT, icon:<EditIcon/>, where: (row) => row.regUser === sessionInfo.user.userId},
            {id:AppObject.command.DELETE, icon:<DeleteForeverIcon/>, color: AppStyle.mui.warning, where: (row) => row.regUser === sessionInfo.user.userId},
        );
    }

    const loadingAny
    = responseList.loading || responseItem.loading
    || responseAdd.loading || responseEdit.loading
    || responseRemove.loading;

    const rootStyle = show ? undefined : {display:'none', visibility:'hidden', pointerEvents:'none'};

    const onClickDebug = () => {
        console.log('pr_bbs_info_add_announce:', authTableTree.tree.pr_bbs_info_add_announce);
    };

    return(
        <ContentConainer style={rootStyle}>
            {viewServiceTags}
            <ContentHeader>
                <ControlBox>
                    <DateRangePicker
                        dateFrom={dateFrom}
                        dateTo={dateTo}
                        onChangeFrom={setDateFrom}
                        onChangeTo={setDateTo}
                    />
                    <Button
                        variant={AppStyle.mui.contained}
                        style={{marginLeft:10}}
                        onClick={onClickGetList}
                        disabled={loadingAny}
                    >
                        조회
                    </Button>
                </ControlBox>
                <ToolBox>
                    <IconButton
                        color={AppStyle.mui.inherit}
                        style={{marginRight:10}}
                        onClick={onClickReload}
                        disabled={loadingAny}
                    >
                        <CachedIcon />
                    </IconButton>
                    {
                        canAdd &&
                        <IconButton
                            color={AppStyle.mui.primary}
                            onClick={onClickAdd}
                            disabled={loadingAny}
                        >
                            <NoteAddIcon />
                        </IconButton>
                    }
                    {
                        showDebug &&
                        <IconButton
                            color={AppStyle.mui.secondary}
                            onClick={onClickDebug}
                        >
                            <EngineeringIcon />
                        </IconButton>
                    }
                </ToolBox>
            </ContentHeader>
            <FlexyTable
                name='announce_bbs'
                tableProps={BbsInfoDict.tableProps}
                records={bbsAnnounceListData.records}
                onRowDoubleClicked={onDoubleClickRow}
                tools={tools}
                onClickTool={onClickToolOnRow}
            />
            <AnnounceBbsView
                open={viewerState.open}
                item={viewerState.item}
                onRequestEdit={onRequestEditFromViewer}
                onClose={onCloseView}
                onRequestReload={onRequestReloadItem}
            />
            <AnnounceBbsInput
                open={editorState.open}
                item={editorState.item}
                onClose={()=>{setEditorState({open:false, item:null})}}
                responseSaving={editorState.item ? responseEdit : responseAdd}
                onRequestSave={onRequestSave}
                onRequestReload={onRequestReloadItem}
            />
        </ContentConainer>
    );
}
